module.exports = __webpack_public_path__ + "app/invited-entity/modals/modal-delete-invited-entity-2STsJKK-.html";